import { render, staticRenderFns } from "./zoroGrid.vue?vue&type=template&id=1ebe40f7&scoped=true&"
import script from "./zoroGrid.vue?vue&type=script&lang=js&"
export * from "./zoroGrid.vue?vue&type=script&lang=js&"
import style0 from "./zoroGrid.vue?vue&type=style&index=0&id=1ebe40f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebe40f7",
  null
  
)

export default component.exports